import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetProjectDetailsQuery } from "../../../services/Reports";
import {
  getProjectDetailsRequest,
  getProjectDetailsFailure,
  getProjectDetailsSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allProjectDetails,
    isLoading: projectDetailsLoading,
    isError: projectDetailsError,
  } = useGetProjectDetailsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.projectDetailsPageNo,
    pageSize: state.projectDetailsPageSize,
    fromDate: new Date(state.projectDetailsFromDate).toLocaleDateString(),
    toDate: new Date(state.projectDetailsToDate).toLocaleDateString(),
    projectId: state.projectId,
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (projectDetailsLoading) {
      dispatch(getProjectDetailsRequest());
    }
    if (projectDetailsError) {
      dispatch(getProjectDetailsFailure(projectDetailsError));
    }
    if (allProjectDetails) {
      dispatch(
        getProjectDetailsSuccess({
          data: allProjectDetails.data.projectDetails[0].data || [],
          totalPages:
            allProjectDetails.data.projectDetails[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allProjectDetails,
    profileData,
    state.projectDetailsFromDate,
    state.projectDetailsToDate,
    state.projectDetailsPageNo,
    state.projectDetailsPageSize,
  ]);
  return <></>;
};
export default Content;
